import type { EmotionJSX } from "@emotion/react/dist/declarations/src/jsx-namespace";
import type { ComponentType } from "react";

import { LiveArticleScrollContextProvider } from "./contexts";

export function withLiveArticleScrollContext<Props extends object>(
  Component: ComponentType<Props>,
) {
  const WrappedComponent = (props: Props) => (
    <LiveArticleScrollContextProvider>
      <Component {...(props as EmotionJSX.LibraryManagedAttributes<typeof Component, Props>)} />
    </LiveArticleScrollContextProvider>
  );
  return WrappedComponent;
}
